// Re-export the canonical notification types from queries so the push/
// subtree has a single import path.
export type {
  AbGroup,
  DeviceGroup,
  DeviceItem,
  ImageCrop,
  NotificationAudience,
  NotificationItem,
  NotificationSchedule,
  NotificationTarget,
  NotificationTargetType,
  NotificationTemplate,
  PickerItem,
  ScheduleType,
  SendRequest,
  SendResponse,
} from '@/queries/notifications';

import type {
  ImageCrop,
  NotificationAudience,
  NotificationTargetType,
  ScheduleType,
} from '@/queries/notifications';

export type SendMode = 'now' | ScheduleType;
export type TriggerKind = 'install_plus_hours' | 'signup' | 'cart_idle' | 'price_drop';

export interface ComposeFormState {
  title: string;
  body: string;
  imageUrl: string;
  imageCrop: ImageCrop;
  imageBgEnabled: boolean;
  imageBgColor: string;
  targetType: NotificationTargetType;
  targetValue: string;
  targetThumbnail: string;
  targetSearch: string;
  includeIos: boolean;
  includeAndroid: boolean;
  includeAr: boolean;
  includeEn: boolean;
  loginStatus: NotificationAudience['login_status'];
  sendMode: SendMode;
  scheduleAt: string;
  cronExpr: string;
  triggerKind: TriggerKind;
  triggerHours: string;
  abEnabled: boolean;
  titleB: string;
  bodyB: string;
  splitA: string;
}

export const INITIAL_COMPOSE_STATE: ComposeFormState = {
  title: '',
  body: '',
  imageUrl: '',
  imageCrop: 'auto',
  imageBgEnabled: false,
  imageBgColor: '#FFFFFF',
  targetType: 'none',
  targetValue: '',
  targetThumbnail: '',
  targetSearch: '',
  includeIos: true,
  includeAndroid: true,
  includeAr: true,
  includeEn: true,
  loginStatus: 'any',
  sendMode: 'now',
  scheduleAt: '',
  cronExpr: '0 9 * * 5',
  triggerKind: 'install_plus_hours',
  triggerHours: '24',
  abEnabled: false,
  titleB: '',
  bodyB: '',
  splitA: '50',
};
